import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="avatar-picker"
// Manages a popover grid for selecting predefined persona avatars
export default class extends Controller {
  static targets = ["trigger", "popover", "option", "hiddenInput", "preview", "placeholder"]

  connect() {
    this._handleOutsideClick = this._handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._handleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    const isHidden = this.popoverTarget.classList.contains("hidden")

    if (isHidden) {
      this.popoverTarget.classList.remove("hidden")
      document.addEventListener("click", this._handleOutsideClick)
    } else {
      this._close()
    }
  }

  select(event) {
    const avatar = event.currentTarget.dataset.avatar
    const avatarPath = event.currentTarget.dataset.avatarPath

    this.hiddenInputTarget.value = avatar
    this.previewTarget.src = avatarPath
    this.previewTarget.classList.remove("hidden")

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }

    // Update ring highlight
    this.optionTargets.forEach((option) => {
      if (option.dataset.avatar === avatar) {
        option.classList.add("ring-2", "ring-indigo-500")
        option.classList.remove("ring-1", "ring-transparent")
      } else {
        option.classList.remove("ring-2", "ring-indigo-500")
        option.classList.add("ring-1", "ring-transparent")
      }
    })

    this._close()
  }

  _close() {
    this.popoverTarget.classList.add("hidden")
    document.removeEventListener("click", this._handleOutsideClick)
  }

  _handleOutsideClick(event) {
    if (!this.popoverTarget.contains(event.target) && !this.triggerTarget.contains(event.target)) {
      this._close()
    }
  }
}
